import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardDescription,
} from "@/components/ui/card";
import { getConfig } from "@/lib/runtime-config";
import { useAuth } from "@/auth/AuthProvider";

export function WrongAppPage() {
  const { identity, signOut } = useAuth();
  const role = identity?.role;
  const config = getConfig();
  const link =
    role === "incident_commander"
      ? config.appStoreCommandUrl
      : config.appStoreFieldUrl;
  const which =
    role === "incident_commander"
      ? "RespAI Command (iPad)"
      : "RespAI Field (iPhone)";
  return (
    <main className="flex h-screen items-center justify-center bg-muted/30 p-6">
      <Card className="w-full max-w-md" data-testid="wrong-app-card">
        <CardHeader>
          <h1 className="text-2xl font-semibold leading-none tracking-tight">
            This dashboard is for department admins
          </h1>
          <CardDescription>
            Your account ({role ?? "unknown"}) belongs in the iOS app.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm">
            Download <strong>{which}</strong> from the App Store to keep working
            from your phone or iPad.
          </p>
          <div className="flex gap-2">
            <a href={link} target="_blank" rel="noreferrer">
              <Button>Open in App Store</Button>
            </a>
            <Button variant="ghost" onClick={() => void signOut()}>
              Sign out
            </Button>
          </div>
        </CardContent>
      </Card>
    </main>
  );
}
